export default `
query QueryInstancesByPropertyIdStartTimeIndex($propertyId: ID!, $from: Float, $to: Float, $after: ID) {
  queryInstancesByPropertyIdStartTimeIndex(
    propertyId: $propertyId, 
    from: $from, 
    to: $to, 
    after: $after
  ) {
    items {
      instanceId
      createdAt
      propertyId    
      serviceProviderId
      processed
    }
    nextToken
  }
}
`;
